import { PropsWithChildren } from 'react'
import { useAuth } from '@/features/auth'
import classes from './Header.module.scss'
import Button from '@/components/ui/Buttons/Button'
import { ReactComponent as RegisterIcon } from '@/assets/icons/add-user.svg'
import { ReactComponent as ProfileIcon } from '@/assets/icons/user.svg'
import { useLogout, useOpenHomePage, useOpenLogIn } from '@/components/ui/Header/Header.hooks'
import { ButtonTrigger } from '@/components/ui/Menu/Trigger'
import { Dropdown } from '@mui/base/Dropdown'
import Menu from '@/components/ui/Menu'
import { ReactComponent as KnotsLogo } from '@/assets/icons/knots.svg'
import ThemeSwitch from '@/components/ThemeSwitch'

export type HeaderProps = PropsWithChildren<object>

export function Header({ children }: HeaderProps) {
  const auth = useAuth()
  const openLogIn = useOpenLogIn()
  const openHomePage = useOpenHomePage(auth.isLoggedIn())
  const logout = useLogout()

  return (
    <div className={classes.root}>
      <div className={classes.logo} onClick={openHomePage} onAuxClick={openHomePage} role={'button'} tabIndex={0}>
        <KnotsLogo />
      </div>
      <div className={classes.actions}>{children}</div>
      {auth.isLoggedIn() ? (
        <Dropdown>
          <ButtonTrigger color={'neutral'} StartIcon={<ProfileIcon />}>
            Profile
          </ButtonTrigger>
          <Menu placement={'bottom-end'}>
            <Menu.Body>
              <Menu.Item isArrowVisible={false}>
                <ThemeSwitch />
              </Menu.Item>
              <Menu.Item
                onClick={() => auth.openInKnots.mutate()}
                disabled={auth.openInKnots.isPending}
                isArrowVisible={false}
              >
                Open in Knots
              </Menu.Item>

              <Menu.Item onClick={logout} isArrowVisible={false}>
                Log out
              </Menu.Item>
            </Menu.Body>
          </Menu>
        </Dropdown>
      ) : (
        <Button color={'neutral'} StartIcon={<RegisterIcon />} onClick={openLogIn}>
          Log in
        </Button>
      )}
    </div>
  )
}
